<template>
  <template v-if="userAuthenticatedAndHasAccess">
    <slot />
  </template>
  <template v-else>
    <slot name="blocked" />
  </template>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineOptions({
  name: 'AppAlumniChecker',
})

defineProps<{
  title: string
}>()

// Add check for if user has access
const userAuthenticatedAndHasAccess = ref(true)
</script>
